import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=b61a6e96&scoped=true&lang=pug"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=b61a6e96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a6e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b61a6e96')) {
      api.createRecord('b61a6e96', component.options)
    } else {
      api.reload('b61a6e96', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=b61a6e96&scoped=true&lang=pug", function () {
      api.rerender('b61a6e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/SearchResults.vue"
export default component.exports